import { lazy } from 'react';

export default function getRoutes(parent = '', error404) {

  return [
    {
      exact: true,
      path: `${parent}`,
      component: lazy(() => import('views/Request/Home')),
    },
    {
      exact: true,
      path: `${parent}/requests`,
      component: lazy(() => import('views/Request/Requests')),
    },
    {
      exact: true,
      path: `${parent}/simulator`,
      component: lazy(() => import('views/Request/Location')),
    },
    {
      exact: true,
      path: `${parent}/simulator_results`,
      component: lazy(() => import('views/Request/Location')),
    },
    {
      exact: true,
      path: `${parent}/location`,
      component: lazy(() => import('views/Request/Location')),
    },
    {
      exact: true,
      path: `${parent}/customer`,
      component: lazy(() => import('views/Request/Customer')),
    },
    {
      exact: true,
      path: `${parent}/documentation`,
      component: lazy(() => import('views/Request/Documentation')),
    },
    {
      exact: true,
      path: `${parent}/documentation_shareholder`,
      component: lazy(() => import('views/Request/DocumentationShareholder')),
    },
    {
      exact: true,
      path: `${parent}/finish`,
      component: lazy(() => import('views/Request/ProcessCompletedSuccessfully')),
    },
    {
      exact: true,
      path: `${parent}/identity`,
      component: lazy(() => import('views/Request/Identity')),
    },
    {
      exact: true,
      path: `${parent}/processing`,
      component: lazy(() => import('views/Request/Processing')),
    },
    {
      exact: true,
      path: `${parent}/relationships`,
      component: lazy(() => import('views/Request/Relationships')),
    },
    {
      exact: true,
      path: `${parent}/stakeholders`,
      component: lazy(() => import('views/Request/Stakeholders')),
    },
    {
      exact: true,
      path: `${parent}/majority_shareholder`,
      component: lazy(() => import('views/Request/MajorityShareholder')),
    },
    {
      exact: true,
      path: `${parent}/sat_connection`,
      component: lazy(() => import('views/Request/SatConnection')),
    },
    {
      exact: true,
      path: `${parent}/credit_bureau_authorization`,
      component: lazy(() => import('views/Request/CreditBureauAuthorization')),
    },
    {
      exact: true,
      path: `${parent}/credit_bureau_otp`,
      component: lazy(() => import('views/Request/CreditBureauOtp')),
    },
    {
      exact: true,
      path: `${parent}/preproposal`,
      component: lazy(() => import('views/Request/PreProposal')),
    },
    {
      exact: true,
      path: `${parent}/propietario_real_pld`,
      component: lazy(() => import('views/Request/PropietarioRealPld')),
    },
    {
      exact: true,
      path: `${parent}/credit_history_check`,
      component: lazy(() => import('views/Request/CreditHistoryCheck')),
    },
    {
      exact: true,
      path: `${parent}/credit_history_check_autorization`,
      component: lazy(() => import('views/Request/CreditHistoryAutorization')),
    },
    {
      exact: true,
      path: `${parent}/credit_confirmation`,
      component: lazy(() => import('views/Request/CreditConfirmation')),
    },
    error404,
  ];
}
